import { useLoaderData } from "react-router-dom";
import Solution from "../interface/SolutionInterface";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

const Answer = () => {
  const solutions = useLoaderData() as Solution[];

  return (
    <>
      <div id="answer-main-container">
        {solutions.map((solution) => (
          <div id="answer-container" key={solution.id}>
            <h4>
              {solution.exercise_type} {solution.exercise_number}
            </h4>
            <ReactMarkdown
              className="markdown"
              children={solution.answer}
              remarkPlugins={[remarkGfm, remarkMath]}
              rehypePlugins={[rehypeRaw, rehypeKatex]}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default Answer;
